import {applyResultCart} from "@Common/logic/checkout/common/apply-result-cart";
import {setNestedValue}  from "@Common/utils/arr-path";
import {chain}           from "@Common/utils/fs";

export const removePromoCode = (pc, {apis}) => ({
    action: async (cart) => {
        const result = await apis.next.cart.updateCart(chain(
            cart,
            (_) => setNestedValue(_, ["removeCredits", "promoCodes",], [pc]),
        ));
        return {
            change: applyResultCart(result),
        };
    },
});
